import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import {
  addEpisodeComment,
  postCommentWithTvShowId,
} from "../Services/commentsApi";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import LoginSignupModal from "./LoginSignupModal";
function AddCommentEpisodes({
  tvShowId,
  mediaCategory,
  episodeObjectId,
  setEpisodeCommentFlag,
}) {
  const [comment, setComment] = useState("");
  const { t } = useTranslation();
  // to handle the login modal
  const [showLoginModal, setShowLoginModal] = useState(false);
  const handleCloseLoginModal = () => setShowLoginModal(false);
  const handleShowLoginModal = () => setShowLoginModal(true);

  const currentUser = JSON.parse(localStorage.getItem("session"));
  const token = localStorage.getItem("token");

  const handleSubmit = (event) => {
    event.preventDefault();

    addEpisodeComment(
      comment,
      currentUser?._id,
      mediaCategory,
      episodeObjectId,
      tvShowId
    )
      .then((response) => {
        toast.success(t("Comment added"), {
          position: "top-center",
        });
        setComment("");
        setEpisodeCommentFlag(true);
      })
      .catch((error) => {});
  };

  return (
    <section className=" mt-5">
      <Modal
        show={showLoginModal}
        onHide={handleCloseLoginModal}
        className="special_modal"
        size="lg"
        centered={true}
      >
        <Modal.Body>
          <LoginSignupModal />
        </Modal.Body>
      </Modal>
      <Row className="add-comment-container">
        {/* <h4 className="mb-2">Add your comment:</h4> */}
        <ToastContainer
          toastStyle={{
            background: "black",
            color: "white",
          }}
        />
        <Col xs={12}>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col xs={12}>
                <Form.Group controlId="comment">
                  <Form.Label>{t("Your Review")}*</Form.Label>
                  <Form.Control
                    className="bg-transparent text-white border-none"
                    as="textarea"
                    rows={3}
                    value={comment}
                    onChange={(event) => setComment(event.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            {currentUser ? (
              <Row>
                <Col xs={6}>
                  <Button
                    type="submit"
                    className="btn btn-hover iq-button py-2"
                  >
                    <i className="fa fa-play mr-1" aria-hidden="true"></i>
                    {t("Submit")}
                  </Button>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col xs={6}>
                  <Button
                    className="btn btn-hover iq-button py-2"
                    onClick={handleShowLoginModal}
                  >
                    <i className="fa fa-play mr-1" aria-hidden="true"></i>
                    {t("Submit")}
                  </Button>
                </Col>
              </Row>
            )}
          </Form>
        </Col>
      </Row>
    </section>
  );
}

export default AddCommentEpisodes;
